import { FC, Suspense, useEffect, useRef, useState } from "react"
import { Outlet, useSearchParams } from "react-router-dom"
import { useUser } from "../context/userProvider";
import PageLoader from "../components/pageLoader";
import { api_routes } from "../helper/api_routes";
import { useAxios } from "../context/axiosProvider";
import { MyProfileType, UserType } from "../helper/types";
import { isAxiosError } from "axios";
import InsufficientPermissionPage from "../pages/insufficientPermissionPage";
import { setCookie } from "react-use-cookie";

/*
  * Layout that checks auth token is valid or not. if valid then persist user data or token else invalidate existing auth token
*/
const PersistUserLoginLayout: FC = () => {
    const [loading, setLoading] = useState<boolean>(true)
    const [isForbidden, setIsForbidden] = useState<boolean>(false)
    const hasCheckedAuth = useRef(false)
    const { setUser, setParentUser, setParentUserOrg, removeUser, userCookieData, parentUserCookieData, parentUserOrgCookieData } = useUser();
    const { axios } = useAxios();
    const [searchParams] = useSearchParams()
    const token = searchParams.get("token")

    useEffect(() => {
        if (hasCheckedAuth.current) return;
        hasCheckedAuth.current = true;

        let isMounted = true;
        const checkUserAuthenticated = async () => {
            // if(userCookieData && parentUserCookieData && parentUserOrgCookieData && isMounted){
            //     try {
            //         await axios.post(api_routes.profile.checkLogin, {});
            //         setUser(userCookieData)
            //         setParentUser(parentUserCookieData)
            //         setParentUserOrg(parentUserOrgCookieData)
            //     } catch (error) {
            //         removeUser();
            //     }
            // }
            // else{
            //     removeUser();
            // }
            // isMounted && setLoading(false)

            if (token) {
                setCookie(process.env.REACT_APP_CURRENT_ENV === "production" ? "portalTokenKey" : "stagingAuthToken", token)
                // Give cookie state a tick and pass auth header explicitly for first bootstrap call.
                await new Promise((resolve) => setTimeout(resolve, 0));
            }

            try {
                const response = await axios.post<{ data: { finalData: UserType } }>(
                    api_routes.profile.checkLogin,
                    {},
                    token ? { headers: { authorization: `Bearer ${token}` } } : undefined
                );
                if (userCookieData && isMounted) {
                    const response = await axios.get(api_routes.profile.myProfile);
                    const profile = response.data.data as MyProfileType;
                    // setUser({
                    //     token: userCookieData.token,
                    //     user: {
                    //         ...userCookieData.user,
                    //         profile: {
                    //             ...userCookieData.user.profile,
                    //             profileImage: profile.profileImage,
                    //             rolePermission: profile.rolePermission
                    //         }
                    //     }
                    // })
                    setUser({
                        token: userCookieData.token,
                        user: {
                            profile: {
                                id: profile.id,
                                name: profile.name,
                                profileImage: profile.profileImage,
                                oid: profile.oId,
                                oname: profile.oname ? profile.oname : userCookieData.user.profile.oname,
                                roles: profile.roles,
                                timezone: profile.timezone ? profile.timezone : userCookieData.user.profile.timezone,
                                teamModerator: profile.teamModerator,   
                                rolePermission: profile.rolePermission,
                                userId: profile.userId,
                            },
                            settings: {
                                RecognitionBodyCharacterLimit: userCookieData.user.settings.RecognitionBodyCharacterLimit,
                                RewardBodyCharacterLimit: userCookieData.user.settings.RewardBodyCharacterLimit,
                                challengeBodyCharacterLimit: userCookieData.user.settings.challengeBodyCharacterLimit,
                                postBodyCharacterLimit: userCookieData.user.settings.postBodyCharacterLimit,
                            },
                        }
                    })
                    if (parentUserCookieData && isMounted) {
                        setParentUser(parentUserCookieData)
                    }
                    if (parentUserOrgCookieData && isMounted) {
                        setParentUserOrg(parentUserOrgCookieData)
                    }
                } else {
                    setUser({
                        token: response.data.data.finalData.token,
                        user: {
                            profile: {
                                id: response.data.data.finalData.user.profile.id,
                                name: response.data.data.finalData.user.profile.name,
                                profileImage: response.data.data.finalData.user.profile.profileImage,
                                oid: response.data.data.finalData.user.profile.oid,
                                oname: response.data.data.finalData.user.profile.oname,
                                roles: response.data.data.finalData.user.profile.roles,
                                timezone: response.data.data.finalData.user.profile.timezone,
                                teamModerator: response.data.data.finalData.user.profile.teamModerator,
                                rolePermission: response.data.data.finalData.user.profile.rolePermission,
                                userId: response.data.data.finalData.user.profile.userId,
                            },
                            settings: {
                                RecognitionBodyCharacterLimit: response.data.data.finalData.user.settings.RecognitionBodyCharacterLimit,
                                RewardBodyCharacterLimit: response.data.data.finalData.user.settings.RewardBodyCharacterLimit,
                                challengeBodyCharacterLimit: response.data.data.finalData.user.settings.challengeBodyCharacterLimit,
                                postBodyCharacterLimit: response.data.data.finalData.user.settings.postBodyCharacterLimit,
                            },
                        }
                    })
                    setParentUser({
                        token: response.data.data.finalData.token,
                        user: {
                            profile: {
                                id: response.data.data.finalData.user.profile.id,
                                name: response.data.data.finalData.user.profile.name,
                                profileImage: response.data.data.finalData.user.profile.profileImage,
                                oid: response.data.data.finalData.user.profile.oid,
                                oname: response.data.data.finalData.user.profile.oname,
                                roles: response.data.data.finalData.user.profile.roles,
                                timezone: response.data.data.finalData.user.profile.timezone,
                                teamModerator: response.data.data.finalData.user.profile.teamModerator,
                                rolePermission: response.data.data.finalData.user.profile.rolePermission,
                                userId: response.data.data.finalData.user.profile.userId,
                            },
                            settings: {
                                RecognitionBodyCharacterLimit: response.data.data.finalData.user.settings.RecognitionBodyCharacterLimit,
                                RewardBodyCharacterLimit: response.data.data.finalData.user.settings.RewardBodyCharacterLimit,
                                challengeBodyCharacterLimit: response.data.data.finalData.user.settings.challengeBodyCharacterLimit,
                                postBodyCharacterLimit: response.data.data.finalData.user.settings.postBodyCharacterLimit,
                            },
                        }
                    })
                    setParentUserOrg({
                        oId: response.data.data.finalData.user.profile.oid,
                        oname: response.data.data.finalData.user.profile.oname
                    })
                }
            } catch (error) {
                if (isAxiosError(error)) {
                    if (error.response?.status === 403) {
                        setIsForbidden(true)
                    } else {
                        setIsForbidden(false)
                        removeUser();
                    }
                } else {
                    setIsForbidden(false)
                    removeUser();
                }
            } finally {
                isMounted && setLoading(false)
            }
        }

        // (userCookieData && parentUserCookieData && parentUserOrgCookieData && isMounted) ? checkUserAuthenticated() : setLoading(false)
        (isMounted) ? checkUserAuthenticated() : setLoading(false)

        return () => { isMounted = false; };

    }, [axios, parentUserCookieData, parentUserOrgCookieData, removeUser, setParentUser, setParentUserOrg, setUser, token, userCookieData])

    if (isForbidden) {
        return (<InsufficientPermissionPage />)
    }

    return (
        <>
            {
                loading ? <PageLoader /> : <Suspense fallback={<PageLoader />}>
                    <Outlet />
                </Suspense>
            }
        </>
    )
}

export default PersistUserLoginLayout